import * as actionTypes from "../actionTypes.js";

const initialState = {
  notes: [],
  noteLimitReached: false,
  maxNotes: null,
};

const noteReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_NOTES:
      return { ...state, notes: action.payload };

    case actionTypes.CREATE_NOTE:
      return { ...state, notes: [action.payload, ...state.notes] };

    case actionTypes.UPDATE_NOTE:
      return {
        ...state,
        notes: state.notes.map(n =>
          n.id === action.payload.id ? { ...n, ...action.payload } : n
        ),
      };

    case actionTypes.DELETE_NOTE:
      return {
        ...state,
        notes: state.notes.filter(n => n.id !== action.payload),
      };

    case actionTypes.NOTE_LIMIT_REACHED:
      return { ...state, noteLimitReached: true, maxNotes: action.payload ?? state.maxNotes };

    case actionTypes.CLEAR_NOTE_LIMIT:
      return { ...state, noteLimitReached: false };

    default:
      return state;
  }
};

export default noteReducer;
